/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import BorderGeometry from 'galax/client/geometry/border';

import * as Hex from 'shared/geo/hex';
import * as Points from 'shared/geo/points';


export default class
{
  constructor (location, parent)
  {
    this.location = location;
    this.parent = parent;

    this.neighbors = this.location.getNeighbors().getLocations();

    this.points = this.__calculatePoints__(this.neighbors);
    this.borders = this.__calculateBorders__(this.points);
  }


  __calculatePoints__ (neighbors)
  {
    if (this.location.isEmpty())
    {
      return this.getExternalPoints();
    }

    return this.parent.getHex().getZonePoints(this.location, neighbors);
  }


  __calculateBorders__ (points)
  {
    let borders = [];

    for (let index = 0; index < Hex.getPointCount(); ++index)
    {
      const currentTriangle = this.__calculateTriangle__(index, points);
      const externalTriangle = this.__calculateTriangle__(index, this.getExternalPoints());

      borders.push(new BorderGeometry(index, currentTriangle, externalTriangle, this));
    }

    return borders;
  }


  __calculateTriangle__ (index, points)
  {
    return [ points[index], points[(index + 1) % Hex.getPointCount()], this.getCenter() ];
  }


  // TODO a different name? getOffset maybe ?
  getTransform ()
  {
    const x = this.location.getCoords().getX();
    const y = this.location.getCoords().getY();

    const xDistance = this.parent.getHex().getHorizontalDistance();
    const yDistance = this.parent.getHex().getVerticalDistance();

    return { x: x * xDistance + (y % 2 ? xDistance / 2 : 0), y: y * yDistance };
  }


  getAbsolute (point = { x: 0, y: 0 })
  {
    const transform = this.getTransform();

    return { x: point.x + transform.x, y: point.y + transform.y };
  }


  getRelative (point)
  {
    const transform = this.getTransform();

    return { x: point.x - transform.x, y: point.y - transform.y };
  }


  getClippedLine (pointA, pointB)
  {
    return Hex.getLineIntersectionPoints(pointA, pointB, this.points);
  }


  getPointsFromBorder (offset)
  {
    // Used by flight ?
    return Hex.getBorders(this.points).map( ({ pointA, pointB }) =>
    {
      const point = Points.scale(Points.add(pointA, pointB), 0.5);

      return this.getAbsolute(Points.getPointWithOffset(this.getCenter(), point, offset));
    });
  }


  getCurrentPoints ()
  {
    return this.points;
  }


  getExternalPoints ()
  {
    return this.parent.getHex().getExternalPoints();
  }


  getNeighbors ()
  {
    return this.neighbors;
  }


  getBorders ()
  {
    return this.borders;
  }


  getCenter ()
  {
    return { x: 0, y: 0 };
  }


  getLocation ()
  {
    return this.location;
  }


  getNeighborGeometry (index)
  {
    return this.parent.getZone(this.neighbors[index])
  }


};
